<template>
  <modern-upload-field
    :label="label"
    :name="name"
    :value="value"
    accept="image/jpeg,image/png,image/webp,image/gif"
    :required="required"
    :uploading="uploading"
    :has-error="fileError || hasError"
    :error-message="errorMessage"
    hint="Choose image (.jpg, .png, .webp)"
    @file-selected="changeFileHandle"
  ></modern-upload-field>
</template>

<script>
import service from '@/services/index'
import { mapActions } from 'vuex'
import ModernUploadField from '@/components/Forms/ModernUploadField'

const resource = service.resource('races/upload-image')
const resourceActionImage = service.resource('races/upload-action-image')

export default {
  name: 'uploadField',
  components: { ModernUploadField },
  props: {
    label: {
      required: false,
      type: String
    },
    value: {
      required: true
    },
    name: {
      required: true,
      type: String
    },
    errorMessage: {
      required: false,
      type: String
    },
    hasError: {
      required: false
    },
    required: {
      type: Boolean
    }
  },
  data: () => ({
    input: '',
    fileError:false,
    uploading: false
  }),
  methods: {
    changeFileHandle (e) {
      const originalFile = e.target.files[0]
      if (!originalFile) {
        return
      }

      const file = new FormData()
      file.append('file', originalFile)
      const size = originalFile.size/1024
      console.log("size---",size)
      if(size > 200){
        this.fileError=true
        this.$emit('input', null)
      }else { 
        console.log("label---",this.label)
        this.fileError=false
        if(this.label == 'Action Image'){
          this.addTaskToQueue('saveActionImage')
          this.uploading = true
          resourceActionImage.save(file)
            .then(({ body }) => {
            this.$emit('input', body.url)
            this.removeTaskFromQueue('saveActionImage')
          }).finally(() => {
            this.uploading = false
          })
        }else{
          this.addTaskToQueue('saveRacePhoto')
          this.uploading = true
          resource.save(file)
            .then(({ body }) => {
            this.$emit('input', body.url)
            this.removeTaskFromQueue('saveRacePhoto')
          }).finally(() => {
            this.uploading = false
          })

        }
       
      } 
    },
    ...mapActions({
      addTaskToQueue: 'LoadingQueue/addTaskToQueue',
      removeTaskFromQueue: 'LoadingQueue/removeTaskFromQueue'
    })
  }
}
</script>



// WEBPACK FOOTER //
// RacePhoto.vue?2bfdc35b